/* @flow */
import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import Copy from 'components/Copy';
import Dialog from 'components/Dialog';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import * as React from 'react';

type Props = {
  hasChildren: boolean,
  onRequestHide?: () => any,
};

export default function UsersInviteLegalDialog(props: Props) {
  return (
    <Dialog
      eventScreenName="UsersInviteLegalDialog"
      {...props}
      title="Adding people on Remind"
      size="small">
      <BoxBody>
        <Copy>
          <p>
            Here are a few guidelines to help you comply with the{' '}
            <Link target="_blank" href={LinkConstants.TERMS_OF_SERVICE}>
              Terms of Service
            </Link>{' '}
            of the Remind platform.
          </p>
          <ol>
            <li>
              <p>
                Before adding anyone to a class, make sure you have their permission to send them
                SMS messages and emails.
              </p>
            </li>
            <li>
              <p>Use Remind only for non-commercial purposes.</p>
            </li>
            <li>
              <p>
                Let people know that normal text messaging rates may apply to messages they receive.
              </p>
            </li>
            {props.hasChildren && (
              <li>
                <p>
                  Remember to get parental consent for students under 13.{' '}
                  <Link target="_blank" href={LinkConstants.PARENTAL_CONSENT}>
                    Learn more
                  </Link>
                </p>
              </li>
            )}
          </ol>
        </Copy>
        <Button onClick={props.onRequestHide}>Got it</Button>
      </BoxBody>
    </Dialog>
  );
}
